import { withBrand } from '@bnnvara/brand';
import { Grid } from '@bnnvara/grids';
import flowRight from 'lodash/flow';
import Head from 'next/head';

import { withComposablePage } from '../../helpers/composable';
import { FetchBrand } from '../../api/queries/brand.gql';
import { ScrollIntoViewContainer } from '../../components/ScrollIntoView';
import { resizeImageSourceMax } from '../../helpers/resizeImageSource';
import withApolloClient from '../withApolloClient';
import composableElementsConfig from './composableElementsConfig';
import getFeatureName from './getFeatureName';

const withBrandedComposablePage = (options) =>
  flowRight(
    withComposablePage({
      ...options,
      composableElementsConfig,
      resizeImageSource: resizeImageSourceMax,
      getFeatureName,
      groupComponent: Grid,
      contentContainerComponent: ScrollIntoViewContainer,
      htmlHeadContainer: Head,
    }),
    withBrand({
      query: FetchBrand,
    }),
    withApolloClient
  );

export default withBrandedComposablePage;
